import ProductApi from "../../services/api/productApi.js";
import ProductDescription from "./productDescription/productDescription.vue";
import SimilarProducts from "../../components/shared/product/similarProducts/similarProducts.vue";
import FavoritesApi from "../../services/api/favoritesApi.js";
import InlineSvg from "vue-inline-svg";

import ProductDescriptionHeader
  from "../../components/shared/product/productDescriptionHeader/productDescriptionHeader.vue";
import {mapGetters} from "vuex";
import utils from "@/services/utils";
import {cartHelper} from "@/components/mixin/cartHelper";
import {productDetailsHelper} from "@/components/mixin/product/productDetailsHelper";
import BreadCrumb from "@/views/TheProductDetailsPage/BreadCrumb";
import VisitorView from "@/views/TheProductDetailsPage/VisitorView";
import ShippingTime from "@/views/TheProductDetailsPage/ShippingTime";


const ProductApiService = new ProductApi(),
  FavoritesApiService = new FavoritesApi();

export default {
  mixins: [cartHelper, productDetailsHelper],
  components: {
    BreadCrumb,
    ProductDescription,
    SimilarProducts,
    ProductDescriptionHeader,
    InlineSvg,
    VisitorView,
    ShippingTime,
  },

  data() {
    return {
      hotListProducts: [],
      product: null,
      totalPrice: 0,
      totalQuantity: 0,
      activeImage: null,
      activeImageIndex: 0,
      quantity: null,
      selectedOption: {},
      faveData: null,
      showVideo: false,
      selectedVariants: [],
    };
  },

  methods: {
    optionDropdownCallback,
    selectVariant,
    getProduct,
    redirect,
    viewImage,
    showNotifyMeModal,
    selectVariantFromReorder,
    handleVideoThumbnailClick,
    getCategoryNameFromProductByCategoryId,
    findCategoryById,
    urlFormatter: utils.urlSafeString,
  },

  async beforeMount() {
    await this.fetchCart();
  },
  mounted() {
    this.$eventBus.$on("refresh-product-cart-summary", this.fetchCartAndUpdateVariants);
    this.getProduct();
  },

  beforeDestroy() {
    this.$eventBus.$off("refresh-product-cart-summary", this.fetchCartAndUpdateVariants);
  },
  computed: {
    isUserLogged() {
      return Boolean(this.user);
    },
    ...mapGetters({
      user: "userState",
    }),
  },
};

function selectVariantFromReorder() {
  this.quantity = this.$store.getters.reorderState.quantity;
  this.selectedOption = this.$store.getters.reorderState.options;

  if (Object.keys(this.selectedOption).length === this.product.characteristics.length) {
    this.selectVariant(this.$utils.findVariantByOptions(this.product.variants, this.selectedOption));
    this.$store.commit("removeReorderState");
  }
}

function optionDropdownCallback(optionValue, optionName) {
  this.selectedOption[optionName] = optionValue;

  if (Object.keys(this.selectedOption).length === this.product.characteristics.length) {
    this.selectVariant(this.$utils.findVariantByOptions(this.product.variants, this.selectedOption));
  }
}

function redirect(path) {
  this.$router.push(path);
}

function selectVariant(variant, quantity) {
  if (variant) {
    this.onChangeSelection([{ variant, quantity }]);

    this.$nextTick(() => {
      for (const [key, value] of Object.entries(this.selectedOption)) {
        this.$refs[key + "_dropdown"][0].selected = value;
      }
    });
  } else {
    this.$swal(
      "Attention",
      "Sorry, this variant is not available at the moment. Please select another combination of options"
    );
  }
}

function showNotifyMeModal() {
  this.$eventBus.$emit("show-notify-me-modal", this.product);
}

function viewImage(index) {
  this.activeImage = this.product.images[index];
  this.activeImageIndex = index;
  this.showVideo = false;
}
function handleVideoThumbnailClick() {
  this.showVideo = true;
}

function getProduct() {
  const _self = this;


  ProductApiService.getProduct(_self.$route.params.productId)
    // eslint-disable-next-line complexity
    .then(async (response) => {
      _self.product = response.data;
      _self.product.description_stripped = _self.$utils.stripHTML(_self.product.description);

      _self.product.brand = {
        company_name: response.data.brand_name,
        id: response.data.brand_id,
        minimum_order_value: response.data.brand_minimum_order_value,
        vanity_url_name: response.data.brand_vanity_url_name,
      };

      _self.product.variants = this.mapVariants(response.data?.variants, _self.product, this.cart);
      _self.hasInStockVariant = _self.product.variants?.filter((variant) => variant.in_stock).length;
      _self.quantity = _self.product.wholesale_minimum;

      if (_self.product.variants.length === 1) {
        _self.selectVariant(_self.product.variants[0]);
      } else if (_self.$store.getters.reorderState) {
        _self.selectVariantFromReorder();
      }

      if (_self.isUserLogged && _self.$session.getUserInfo().role === "RETAILER") {
        const orderCount = (await _self.$utils.getOrderCount(_self.product.brand.id)).data.order_count;

        if (orderCount > 0) {
          _self.product.brand.minimum_order_value = response.data.brand_minimum_reorder_value;
        }
      }

      if (_self.isUserLogged && this.$session.getUserInfo().role === "RETAILER") {
        FavoritesApiService.getFavoriteProducts()
          .then((response) => {
            let ids = response.data.product_ids;
            if (ids === undefined) {
              ids = [];
            }
            _self.faveData = {
              is_fav: ids.includes(_self.product.id),
              id: _self.product.id,
            };
          })
          .catch((error) => {
            if (error.response) {
              _self.$swal("Attention", error.response.data.error_message);
            } else {
              _self.$logger.notify(new Error(error));
            }
          });
      }
      _self.$ma.trackEvent({
        action: "View PDP",
        properties: {
          "Pdp Type": "pdp",
          "Entry Point": document.referrer,
          "Product Name": _self.product.name,
          "Product Id": _self.product.id,
          Brand: _self.product.brand.company_name,
        },
      });
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    });
}

function getCategoryNameFromProductByCategoryId() {
  const category = this.findCategoryById();
  if (category) {
    return category?.name;
  }
}

function findCategoryById() {
  const categoryIdFromPath = this.$route.params.categoryId,
    { categories } = this.product || {};

  if (categories && categories.length) {
    return categories.find((item) => String(item.id) === categoryIdFromPath);
  }
}
